import { render } from "./SelectSuperior.vue?vue&type=template&id=5c39493c&scoped=true"
import script from "./SelectSuperior.vue?vue&type=script&lang=js"
export * from "./SelectSuperior.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/boletiland/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c39493c"]])

export default __exports__